import { QA_API_DOMAIN, fetchWithSupabaseAuth } from "@/api/classifier";
import { useState } from "react";

export function useRerunWithDecisionLog() {
  const [isLoading, setIsLoading] = useState(false);

  const rerunWithDecisionLog = async (encounterId: string) => {
    setIsLoading(true);
    try {
      const res = await fetchWithSupabaseAuth(`${QA_API_DOMAIN}/encounters/encounters/process-with-decision-log`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ encounterId }),
      });
      if (!res.ok) {
        const errorData = await res.json().catch(() => null);
        throw new Error(errorData?.error || errorData?.message || `HTTP ${res.status}`);
      }
      return await res.json();
    } finally {
      setIsLoading(false);
    }
  };

  return { rerunWithDecisionLog, isLoading };
}
